import Class from '@/Class';
import type ControlFactory from '@/Factories/ControlFactory';

export default class ControlFactoryTuple extends Class {

    public control: JQuery<HTMLElement>;
    public label: JQuery<HTMLElement>;
    public factory: ControlFactory;

    constructor(factory: ControlFactory, control: JQuery, label: JQuery) {
        super();

        this.factory = factory;
        this.control = control;
        this.label = label;

        this.undisposeProperties.push('factory');
        this.isDisposable = true;
    }
}